import { http } from '@/common/utils/HttpServices';
import { Routes } from '@/api/Routes';
import { AxiosResponse } from 'axios';
import { DevisValidationDetailsDTO, DevisValidationResultDTO } from '@/models/DevisValidation';

class DevisValidationService {
    public async getDetails(token: string): Promise<AxiosResponse<DevisValidationDetailsDTO>> {
        return await http.get<DevisValidationDetailsDTO>(Routes.DevisValidationRoutes.GetDetails(token));
    }

    public async confirmer(token: string): Promise<AxiosResponse<DevisValidationResultDTO>> {
        return await http.post<DevisValidationResultDTO>(Routes.DevisValidationRoutes.PostConfirmer(token), {});
    }

    public async getPdf(token: string): Promise<AxiosResponse<Blob>> {
        return await http.get(Routes.DevisValidationRoutes.GetPdf(token), { responseType: 'blob' });
    }
}

export default new DevisValidationService();
